import React, { useState } from 'react';
import { Section, FadeIn, Button } from './ui';
import { ChevronDown, ShieldCheck } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Necesito comprar suplementos caros?',
  a: 'No, el plan usa elementos básicos: luz solar, agua y alimentos reales.'
}, {
  q: '¿Es muy difícil de seguir?',
  a: 'No, está diseñado para mujeres ocupadas con pasos de 5 a 10 minutos.'
}, {
  q: '¿Tengo que dejar el café?',
  a: 'No, solo aprenderás a tomarlo en el momento en que no dañe tu energía.'
}, {
  q: '¿Funciona si ya pasé la menopausia?',
  a: 'Sí, los principios de sincronización hormonal son vitales para toda la post-menopausia.'
}, {
  q: '¿Cuánto tiempo toma ver resultados?',
  a: 'Los cambios en la claridad mental suelen notarse en los primeros 3 a 5 días.'
}, {
  q: '¿Es un plan de dieta?',
  a: 'Es un plan de energía. La nutrición es una parte, pero el enfoque es la vitalidad celular.'
}];
const AccordionItem = ({
  q,
  a
}: {
  q: string;
  a: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-cream-dark last:border-0" data-id="element-49">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none" data-id="element-50">
        <span className="text-lg font-bold text-brown pr-8" data-id="element-51">{q}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-52">
          <ChevronDown className="w-5 h-5 text-gold" data-id="element-53" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-54">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-55">
            <p className="pb-6 text-brown-light" data-id="element-56">{a}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export const FAQSection = () => {
  return <>
      <Section bg="bg-white" data-id="element-57">
        <FadeIn data-id="element-58">
          <div className="max-w-3xl mx-auto" data-id="element-59">
            <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-60">
              Preguntas Frecuentes
            </h2>
            <div className="bg-cream-light rounded-3xl p-6 md:p-10 shadow-sm" data-id="element-61">
              {faqs.map((faq, i) => <AccordionItem key={i} q={faq.q} a={faq.a} data-id="element-62" />)}
            </div>
          </div>
        </FadeIn>
      </Section>

      <Section bg="bg-cream-dark/30" className="border-t border-cream-dark" id="precio" data-id="element-63">
        <FadeIn data-id="element-64">
          <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden" data-id="element-65">
            <div className="grid md:grid-cols-2" data-id="element-66">
              <div className="p-10 md:p-12 flex flex-col justify-center" data-id="element-67">
                <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-68">
                  Recupera tu energía hoy por el precio de tres cafés.
                </h2>
                <p className="text-lg text-brown-light mb-8" data-id="element-69">
                  Obtén el Plan de 21 Días de Vitalidad Menopáusica con todas
                  las guías y herramientas de implementación inmediata.
                </p>

                <div className="mb-8" data-id="element-70">
                  <span className="text-sm text-brown-light uppercase tracking-wider font-bold" data-id="element-71">
                    Inversión única
                  </span>
                  <div className="flex items-baseline gap-3 mt-1" data-id="element-72">
                    <span className="text-2xl text-brown-light/50 line-through font-medium" data-id="element-73">
                      $19
                    </span>
                    <span className="text-5xl font-bold text-coral" data-id="element-74">$6.39</span>
                    <span className="text-2xl text-brown-light font-normal" data-id="element-75">
                      USD
                    </span>
                  </div>
                  <span className="inline-block mt-2 bg-sage-light text-sage text-sm font-bold px-3 py-1 rounded-full" data-id="element-76">
                    ¡Ahorra 66%!
                  </span>
                </div>

                <Button fullWidth href="https://edadradiante.com/cart/52950970204271:1" data-id="element-77">
                  ¡SÍ, QUIERO RECUPERAR MI ENERGÍA AHORA!
                </Button>

                <div className="mt-6 flex items-center justify-center gap-2 text-sm text-brown-light" data-id="element-78">
                  <ShieldCheck className="w-5 h-5 text-sage" data-id="element-79" />
                  <span data-id="element-80">
                    Acceso instantáneo tras la compra. Tu nueva vitalidad
                    comienza mañana mismo.
                  </span>
                </div>
              </div>

              <div className="bg-sage-light/20 p-10 flex items-center justify-center relative overflow-hidden" data-id="element-81">
                <div className="absolute inset-0 bg-gradient-to-br from-sage/10 to-transparent" data-id="element-82"></div>
                <img src="https://cdn.magicpatterns.com/uploads/9G6aWdx1gpXNMEYmywpptz/Plan_21_Dias_de_Vitalidad_Menopausica.png" alt="Plan de 21 Días" className="w-full max-w-sm rounded-xl shadow-2xl relative z-10 transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-83" />
              </div>
            </div>
          </div>
        </FadeIn>
      </Section>
    </>;
};